import { decryptData } from "./encryptionUtils"

// get Logged In User
export const getLoggedInUser = () => {
  const currentUser = JSON.parse(localStorage.getItem("authUser"))
  return currentUser
}
// check if the user Loggen In or not
export const isUserAuthinticated = () => {
  return getLoggedInUser() ? true : false
}

// get Logged In User
export const getMainBroker = () => {
  return getLoggedInUser()
}

// get Logged In customer
export const getMainCustomer = () => {
  const mainCustomer = localStorage.getItem("mainCustomer")
    ? decryptData(localStorage.getItem("mainCustomer"))
    : undefined
  return mainCustomer
}
// get Logged In Reinsurer
export const getMainReinsurer = () => {
  const mainReinsurer = localStorage.getItem("mainReinsurer")
    ? decryptData(localStorage.getItem("mainReinsurer"))
    : undefined
  return mainReinsurer
}
// check if customer

export const isCustomerUser = () => {
  const mainCust = getMainCustomer()
  const mainReins = getMainReinsurer()
  return mainCust && !mainReins ? true : false
}
// check if reinsurer
export const isReinsurerUser = () => {
  const mainReins = getMainReinsurer()
  const mainCust = getMainCustomer()
  return mainReins && !mainCust ? true : false
}
